import { render, staticRenderFns } from "./AutomatedABTests.vue?vue&type=template&id=35a1d667&scoped=true&"
import script from "./AutomatedABTests.vue?vue&type=script&lang=js&"
export * from "./AutomatedABTests.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedABTests.vue?vue&type=style&index=0&id=35a1d667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1d667",
  null
  
)

export default component.exports